import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Button, Modal } from "semantic-ui-react";

import { gameActions } from "../../store/game-slice";

import BingoBoard from "./BingoBoard";
import ClockTimer from "./ClockTimer";
import GameMenu from "./GameMenu";
import ThemeChooser from "../ThemeChooser";

function BingoGame() {
  const dispatch = useDispatch();

  const gameRestarted = useSelector((state) => state.game.gameRestarted);
  const startClock = useSelector((state) => state.game.startClock);
  const clockRunning = useSelector((state) => state.game.clockRunning);
  const gameWon = useSelector((state) => state.game.gameWon);

  const [themeChooseOpen, setThemeChooseOpen] = useState(false);
  const [howToPlayOpen, setHowToPlayOpen] = useState(false);
  const [bestTimesOpen, setBestTimesOpen] = useState(false);
  const [bestTimes, setBestTimes] = useState([]);

  useEffect(() => {
    if (gameRestarted) {
      dispatch(gameActions.setGameRestarted(false));
      resetModals();

      const times = JSON.parse(localStorage.getItem("times"));
      if(times != null) {
        let timesRanked = [];
        for(let i = 0; i < times.length; i++) {
          timesRanked.push({
            gamenum: (i+1),
            time: times[i]
          });
        }
        timesRanked.sort((a,b) => (a.time > b.time) ? 1 : ((b.time > a.time) ? -1 : 0))
        setBestTimes(timesRanked);
      } else {
        setBestTimes([]);
      }
    }
  }, [dispatch, gameRestarted]);

  function resetModals() {
    setThemeChooseOpen(false);
    setHowToPlayOpen(false);
    setBestTimesOpen(false);
  }

  function btnChooseThemeClickHander() {
    resetModals();
    setThemeChooseOpen(true);
    dispatch(gameActions.setActiveModal('theme'));
  }

  function btnHowToPlayClickHander() {
    resetModals();
    setHowToPlayOpen(true);
    dispatch(gameActions.setActiveModal('howtoplay'));
  }

  function btnBestTimesClickHander() {
    resetModals();
    setBestTimesOpen(true);
    dispatch(gameActions.setActiveModal('besttimes'));
  }

  function btnClearPastTimesClickHandler() {
    localStorage.setItem('times', JSON.stringify([]));
    setBestTimes([]);
  }

  function startStopClockHandler(startOrStop, gameWon) {
    dispatch(gameActions.setStartClock(startOrStop));
    dispatch(gameActions.setClockRunning(startOrStop));
    if(gameWon) {
      dispatch(gameActions.setGameWon(true));
    }
  }

  return (
    <div>
      <div><img src="images/ez-bingo.svg" className="game-logo"/></div>
      <section className="bingo-game">
        <ClockTimer isGameRestarted={gameRestarted} isClockRunning={clockRunning} startClock={startClock} isGameWon={gameWon} />
        <BingoBoard isGameRestarted={gameRestarted} onStartStopClockHandler={startStopClockHandler} />
        <GameMenu
          isInModal={false}
          showRestart={true}
          onChooseThemeClickHander={btnChooseThemeClickHander}
          onHowToPlayClickHander={btnHowToPlayClickHander}
          onBestTimesClickHander={btnBestTimesClickHander}
          onClickStartStopClockHandler={startStopClockHandler}
        />
        <Modal
          className="animate flip"
          closeIcon
          open={themeChooseOpen}
          onClose={() => {
            setThemeChooseOpen(false);
          }}
        >
          <Modal.Content>
            <ThemeChooser buttonLabel="Back to Game" onPlayClick={() => setThemeChooseOpen(false)} />
            <GameMenu
              isInModal={true}
              showRestart={false}
              onChooseThemeClickHander={btnChooseThemeClickHander}
              onHowToPlayClickHander={btnHowToPlayClickHander}
              onBestTimesClickHander={btnBestTimesClickHander}
            />
          </Modal.Content>
        </Modal>
        <Modal
          className="animate flip"
          closeIcon
          open={howToPlayOpen}
          onClose={() => {
            setHowToPlayOpen(false);
          }}
        >
          <Modal.Content>
            <h3>How to Play</h3>
            <p>
            To get started, select a theme then tap “Let&rsquo;s Play.” As a symbol or picture is called, check your card to see if you have that same symbol or picture. If you do, mark it off by tapping on that box. The goal of the game is to complete a row on your card (horizontal, vertical, or diagonal). When that happens, you have “Bingo!” Play multiple games and try to beat your best time.
            </p>
            <p><img src="images/ways-to-win.svg" className="how-pop"></img></p>
            <Button
              onClick={() => {
                setHowToPlayOpen(false);
              }}
            >
              Back to the Game
            </Button>
            <GameMenu
              isInModal={true}
              showRestart={false}
              onChooseThemeClickHander={btnChooseThemeClickHander}
              onHowToPlayClickHander={btnHowToPlayClickHander}
              onBestTimesClickHander={btnBestTimesClickHander}
            />
          </Modal.Content>
        </Modal>
        <Modal
          className="animate flip"
          closeIcon
          open={bestTimesOpen}
          onClose={() => {
            setBestTimesOpen(false);
          }}
        >
          <Modal.Content>
            <h3>Your Best Times</h3>
            {bestTimes != null && bestTimes.length > 0 && (
              <ul className="best-times">
                {bestTimes.map((time, i) => (
                  <li key={time.gamenum}>
                    <div>Game {time.gamenum}</div> <div>{time.time}</div>
                  </li>
                ))}
              </ul>
            )}
            {bestTimes.length === 0 && <p>You do not have any saved game times.</p>}
            <p className="clear">
              <a href="#" onClick={btnClearPastTimesClickHandler}>Clear Past Scores</a>
            </p>
            <Button
              onClick={() => {
                setBestTimesOpen(false);
              }}
            >
              Back to the Game
            </Button>
            <GameMenu
              isInModal={true}
              showRestart={false}
              onChooseThemeClickHander={btnChooseThemeClickHander}
              onHowToPlayClickHander={btnHowToPlayClickHander}
              onBestTimesClickHander={btnBestTimesClickHander}
            />
          </Modal.Content>
        </Modal>
      </section>
    </div>
  );
}

export default BingoGame;
